export default __webpack_public_path__ + "img/6a610b097362e42efbe381562af74341.svg";